// rootReducer.ts
import { combineReducers } from "redux";
import plaidReducer from "./plaid-store/plaid-reducer";
import transactionsReducer from "./transactions-store/transactions-reducer";
import bankAccountReducer from "./bank-account-store/bank-account-reducer";
import propertiesReducer from "./properties-store/properties-reducer";
import organizationsReducer from "./organizations-store/organizations-reducer";
import maintenanceReducer from "./maintenance-store/maintenance-reducer";
import categorizationRulesReducer from "./categorization-rules-store/categorization-rules-reducer";

const rootReducer = combineReducers({
  plaid: plaidReducer,
  transactions: transactionsReducer,
  bankAccount: bankAccountReducer,
  properties: propertiesReducer,
  organizations: organizationsReducer,
  maintenance: maintenanceReducer,
  categorizationRules: categorizationRulesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
